import { render, staticRenderFns } from "./HappinessDashboard.vue?vue&type=template&id=555ecf22&"
import script from "./HappinessDashboard.vue?vue&type=script&lang=js&"
export * from "./HappinessDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HappinessDashboard.vue?vue&type=style&index=0&id=555ecf22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports